module.exports = __webpack_public_path__ + "img/service-mgs.19fb868.svg";